import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'apollo-client/util/Observable';
import * as _ from 'lodash';
import { IMyOptions, ToastService } from 'ng-uikit-pro-standard';
import { ModalDirective } from 'ng-uikit-pro-standard/lib/free/modals/modal.directive';
import { Subject } from 'rxjs';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { ParametroEmpresaService } from 'src/app/services/parametro-empresa.service';
import { RecorridoDetalleService } from 'src/app/services/recorrido-detalle.service';
import { RecorridoService } from 'src/app/services/recorrido.service';
import { RuteadorService } from 'src/app/services/ruteador.service';
import { SignalRMessageService } from 'src/app/services/SignalRMessage.service';
import { SignalRService } from 'src/app/services/SignalRNegotiate.service';
import { ModalConfirmComponent } from 'src/app/shared/components/modal-confirm/modal-confirm.component';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { unidad_negocio } from 'src/app/shared/object/unidad_negocio.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { FileDownloadService } from 'src/app/shared/services/file-download.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { ENVIRONMENT_FUNCTIONS } from 'src/environments/environment';
import { CamionSucursalService } from '../../services/camion-sucursal.service';
import { ChoferSucursalService } from '../../services/chofer-sucursal.service';
import { UnidadNegocioService } from '../../services/unidad-negocio.service';
import { DatesService } from '../../shared/services/dates.service';
import { GraphQLClient } from '../../shared/services/graph-qlclient.service';
import { SecurityService } from '../../shared/services/security.service';
import { ModalAddEditRutasComponent } from '../ruteador/modal-add-edit-ruta/modal-add-edit-ruta.component';
import { RuteadorModalAsignarComponent } from '../ruteador/modal-asignar/modal-asignar.component';
import { ModalRutasCamionComponent } from '../ruteador/modal-rutas-camion/modal-rutas-camion.component';

declare const google: any;

@Component({
  selector: 'app-ruteador-manual',
  templateUrl: './ruteador-manual.component.html',
  styleUrls: ['./ruteador-manual.component.scss'],
  providers: [SecurityService, SignalRService],
})
export class RuteadorManualComponent implements OnInit {
  @Output() onSuccess: EventEmitter<void> = new EventEmitter<void>();

  eventsSubject: Subject<void> = new Subject<void>();

  @ViewChild('verDetalleCamionChofer', { static: true }) verDetalleCamionChoferModal: ModalDirective;
  @ViewChild('asignarCamionRutas', { static: true }) asignarCamionRutasModal: ModalDirective;
  @ViewChild(ModalRutasCamionComponent, { static: true }) mostrarRutasModal: ModalRutasCamionComponent;
  // @ViewChild('mostrarRutas', { static: true }) mostrarRutasModal: ModalDirective; // MODAL ANTIGUO QUE MOSTRABA LA RUTA EN EL MAPA
  @ViewChild(ModalConfirmComponent, { static: true }) modalConfirm: ModalConfirmComponent;
  @ViewChild(ModalAddEditRutasComponent, { static: true }) verAddEditRutasModal: ModalAddEditRutasComponent;

  @ViewChild(RuteadorModalAsignarComponent, { static: true }) modalAsignarCamion: RuteadorModalAsignarComponent;

  @ViewChild('pdf_data', { static: true }) pdf_data: ModalDirective;

  private client: GraphQLClient = null;
  public busquedaEstado;
  public rutEmpresa;
  public rutUsuario;
  public sucursalCodigo;
  formRuta: FormGroup;

  public filtroEstado: string;
  public filtroComuna: string;
  public filtroVendedor: string;
  public filtroTerritorio: string;
  public filtroFecha: string;
  public filtroFechaHasta: string;

  public rutEMpresa: any;

  public polygon: any;

  public drawingManager: any;

  public directionsService: any;

  public directionsRenderer: any;

  center: any = {
    lat: -33.4890772,
    lng: -70.657567,
  };

  beaches = [];
  beachesAUX = [];
  beaches_rutas = [];
  polygonArray = [];
  globalMap: any;
  globalMap_rutas: any;

  optionsEstado: Array<any> = [];
  optionsEstadoDetalle: Array<any> = [];
  optionsComuna: Array<any> = [];
  optionsTerritorios: Array<any> = [];
  optionsVendedor: Array<any> = [];
  documentosRecorridos: Array<any> = [];
  listadoCamionChofer: Array<any> = [];
  optionsCamiones: Array<any> = [];

  listadoDetalleCamionChofer: Array<any> = [];
  listadoDetalleCamionChoferAll: Array<any> = null;
  paginationContextDetalles: PaginationContext = new PaginationContext();
  loadingDetalles: boolean = false;
  listadoDetalleDocumentos: Array<any> = [];
  date: any;

  beachesSeleccionados = [];

  total_documentos: any;
  documentos_entregados: any;
  documentos_pendientes: any;
  numeros_clientes: any;

  tittle: string;
  message: string;
  optionsChofer: Array<any> = [];
  optionsCamion: Array<any> = [];
  camion: any = null;
  chofer: any = null;
  loading: boolean;
  loadingPdf: boolean = false;
  loadingPdfModal: boolean = false;
  messageLoading: string = '';
  recorridoDetalleSeleccionado: any = null;
  recorridoSeleccionado: any = null;
  recorridoSub: Subscription;
  // Unidad de negocio
  optionsUnidadesDeNegocio: unidad_negocio[] = [];
  public permiteUnidadNegocio: boolean = false;
  private isCheckingUnidadNegocio: boolean = true;

  //    placeIdArrayStr = [];
  //  polylinesStr = [];
  //  snappedCoordinatesStr = []

  // Utils
  private log: any;
  formRuteadorManual: FormGroup;

  showTable: boolean = false;
  listdocumentRec: Array<any> = [];
  listdocumentRecAll: Array<any> = [];
  sumTotalCajas: number = 0;
  sumTotalUnidad: number = 0;
  sumTotalPeso: number = 0;
  sumTotalVolumen: number = 0;
  sumTotalMonto: number = 0;
  sumTotalDocumentos: number = 0;
  resumen_totales: any;
  areSelected: boolean;
  CheckBoxAllValue: boolean = false;
  checkAllRecorrido: boolean = false;
  listdocumentRecSelect: Array<any> = [];
  sumCajasSelect: number = 0;
  sumUnidadSelect: number = 0;
  sumPesoSelect: number = 0;
  sumMontoSelect: number = 0;
  sumVolumenSelect: number = 0;
  totalCajas: number = 0;
  totalUnidad: number = 0;
  HighlightRow: number;
  PintarRow: number;
  private currentPayload: any = null;
  listaDocumentosReasignar: any;
  loadingCamion: boolean = false;
  listaDocumentoAsignado: Array<any> = [];
  listaDocumentoAsignadoSelect: Array<any> = [];
  listaDocumentoAsignadoAll: Array<any> = [];
  listaModalAsignado: Array<any> = [];
  totales: any;

  constructor(
    private accesolocalstorage: SecurityService,
    private clog: ConsoleService,
    private fb: FormBuilder,
    private _formValidatorsService: FormValidatorsService,
    private datesService: DatesService,
    private unidadNegocioService: UnidadNegocioService,
    private _parametroEmpresaService: ParametroEmpresaService,
    private _messageRendererService: MessageRendererService,
    private ruteadorService: RuteadorService,
    private camionService: CamionSucursalService,
    private choferSucursalService: ChoferSucursalService,
    private recorridoService: RecorridoService,
    private toastService: ToastService,
    private _recorridoDetalleService: RecorridoDetalleService,
    private messageRendererService: MessageRendererService,
    private fileDownloadService: FileDownloadService,
    private toastrService: ToastService,
    private signalRMessageService: SignalRMessageService,
    private signalRService: SignalRService,
  ) {
    this.formRuta = new FormGroup({
      chofer: new FormControl({ value: '' }),
      camion: new FormControl({ value: '' }),
      negocio: new FormControl({ value: '' }),
      monto: new FormControl({ value: '' }),
      fechaMain: new FormControl(null),
    });

    this.log = this.clog.log('RUTEADOR MANUAL');
  }

  get listadoCamionChoferSelectCount(): number {
    return this.listadoCamionChofer.filter((x) => x.seleccion).length;
  }

  ngOnInit() {
    this.rutEmpresa = this.accesolocalstorage.getRutEmpresa();
    this.rutUsuario = this.accesolocalstorage.getRutUsuario();
    this.sucursalCodigo = this.accesolocalstorage.getSucursalCodigo();

    this.paginationContextDetalles.RecordsByPage = 100;

    this.isCheckingUnidadNegocio = true;

    this.createForms();
    this.initMap();

    this.suscribeSignalRMessage();
    this.updateBloqueoProcesoSignalR();

    this.checkUnidadNegocio();

    const inputParams = {
      unidad_negocio_codigo: this.permiteUnidadNegocio ? this.formRuteadorManual.get('unidad_negocio_codigo').value : 0,
      fechaDesde: this.formRuteadorManual.get('fechafiltroDesde').value,
      fechaHasta: this.formRuteadorManual.get('fechafiltroHasta').value,
      estado: this.formRuteadorManual.get('estadofiltro').value,
      rut_empresa: this.rutEmpresa,
      comuna_codigo: this.formRuteadorManual.get('comunafiltro').value,
      vendedor_codigo: this.formRuteadorManual.get('vendedorfiltro').value,
      territorio_codigo: this.formRuteadorManual.get('territoriofiltro').value,
    };

    this.loadUnidadNegocio();
    this.loadInitialData();

    this.recorridoSub = this.recorridoService.recorridoSeleccionado$.subscribe(async (r) => {
      this.recorridoSeleccionado = r;
      console.log('=>(ruteador.component.ts:185) this.recorridoSeleccionado', this.recorridoSeleccionado);
      if (this.recorridoSeleccionado) {
        this.formRuta.get('camion').setValue(this.recorridoSeleccionado.patente);
        this.formRuta.get('chofer').setValue(this.recorridoSeleccionado.chofer_rut);
        this.setCamion();
        this.setChofer();
      }
    });

    this.loadTerritorios(inputParams);
    this.loadComunas(inputParams);
    this.loadVendedores(inputParams);

    this.optionsEstado = [
      { value: '0', label: 'Seleccionar Estado' },
      { value: '1', label: 'Asignado' },
      { value: '2', label: 'No Asignado' },
    ];

    this.optionsEstadoDetalle = [
      { value: '0', label: 'Todos los estados' },
      { value: '1', label: 'En carga' },
      { value: '2', label: 'Despachado' },
      { value: '3', label: 'Liquidado' },
      // { value: "4", label: "No asignado" }
    ];

    this.formRuteadorManual.get('estadofiltro').setValue('2');
    this.formRuteadorManual.get('estadofiltroDetalleRecorrido').setValue('0');

    this.buscarPorFiltros();
    this.showTable = false;

  }

  suscribeSignalRMessage() {
    this.signalRService.init();
    this.signalRService.messages.subscribe((message) => {
      this.handleMessage(message);
    });
  }

  handleMessage(message: any) {
    const data = JSON.parse(message);
    console.log('message recibido', message, data);
    if (data && data.length > 0) {
      const tipo = data.tipo_notificacion_codigo;
      const categoria = data.categoria_modulo_codigo;
      const id = `${tipo}_${categoria}`;
      if (!sessionStorage.getItem(`processSignal${id}`)) {
        this.loadingPdf = false;
        this.loadingPdfModal = false;
      }
    }
  }

  checkUnidadNegocio() {
    this._parametroEmpresaService.permiteUnidadNegocio(Number(this.rutEmpresa), ({ respuesta, mensajes }) => {
      if (mensajes && mensajes.length > 0) {
        this._messageRendererService.showErrors(mensajes);
        return;
      }
      this.permiteUnidadNegocio = respuesta.valor_bool;

      if (this.permiteUnidadNegocio) {
        this.loadUnidadNegocio();
      } else {
        this.isCheckingUnidadNegocio = false;
        this.loadInitialData();
      }
    });
  }

  filtroPorFecha(e, bandera: boolean = false) {
    var inputParams = {};
    if (bandera === true) {
      inputParams = {
        unidad_negocio_codigo: this.permiteUnidadNegocio ? this.formRuteadorManual.get('unidad_negocio_codigo').value : 0,
        fechaDesde: this.formRuteadorManual.get('fechafiltroDesde').setValue(e.actualDateFormatted),
        fechaHasta: this.formRuteadorManual.get('fechafiltroHasta').value,
        estado: this.formRuteadorManual.get('estadofiltro').value > 0 ? this.formRuteadorManual.get('estadofiltro').value : null,
        rut_empresa: this.rutEmpresa,
        comuna_codigo: this.formRuteadorManual.get('comunafiltro').value > 0 ? this.formRuteadorManual.get('comunafiltro').value : null,
        vendedor_codigo: this.formRuteadorManual.get('vendedorfiltro').value > 0 ? this.formRuteadorManual.get('vendedorfiltro').value : null,
        territorio_codigo: this.formRuteadorManual.get('territoriofiltro').value > 0 ? this.formRuteadorManual.get('territoriofiltro').value : null,
      };
    } else {
      inputParams = {
        unidad_negocio_codigo: this.permiteUnidadNegocio ? this.formRuteadorManual.get('unidad_negocio_codigo').value : 0,
        fechaDesde: this.formRuteadorManual.get('fechafiltroDesde').value,
        fechaHasta: this.formRuteadorManual.get('fechafiltroHasta').setValue(e.actualDateFormatted),
        estado: this.formRuteadorManual.get('estadofiltro').value > 0 ? this.formRuteadorManual.get('estadofiltro').value : null,
        rut_empresa: this.rutEmpresa,
        comuna_codigo: this.formRuteadorManual.get('comunafiltro').value > 0 ? this.formRuteadorManual.get('comunafiltro').value : null,
        vendedor_codigo: this.formRuteadorManual.get('vendedorfiltro').value > 0 ? this.formRuteadorManual.get('vendedorfiltro').value : null,
        territorio_codigo: this.formRuteadorManual.get('territoriofiltro').value > 0 ? this.formRuteadorManual.get('territoriofiltro').value : null,
      };
    }

    this.buscarPorFiltros();
    this.showTable = false;
  }

  onChangeComuna(e) {
    const inputParams = {
      unidad_negocio_codigo: this.permiteUnidadNegocio ? this.formRuteadorManual.get('unidad_negocio_codigo').value : 0,
      fechaDesde: this.formRuteadorManual.get('fechafiltroDesde').value,
      fechaHasta: this.formRuteadorManual.get('fechafiltroHasta').value,
      estado: this.formRuteadorManual.get('estadofiltro').value,
      rut_empresa: this.rutEmpresa,
      comuna_codigo: this.formRuteadorManual.get('comunafiltro').value,
      vendedor_codigo: this.formRuteadorManual.get('vendedorfiltro').value > 0 ? this.formRuteadorManual.get('vendedorfiltro').value : null,
      territorio_codigo: this.formRuteadorManual.get('territoriofiltro').value > 0 ? this.formRuteadorManual.get('territoriofiltro').value : null,
    };

    // this.loadVendedores(inputParams);
    // this.loadTerritorios(inputParams);
  }

  onChangeVendedor(e) {
    const inputParams = {
      unidad_negocio_codigo: this.permiteUnidadNegocio ? this.formRuteadorManual.get('unidad_negocio_codigo').value : 0,
      fechaDesde: this.formRuteadorManual.get('fechafiltroDesde').value,
      fechaHasta: this.formRuteadorManual.get('fechafiltroHasta').value,
      estado: this.formRuteadorManual.get('estadofiltro').value,
      rut_empresa: this.rutEmpresa,
      comuna_codigo: this.formRuteadorManual.get('comunafiltro').value > 0 ? this.formRuteadorManual.get('comunafiltro').value : null,
      vendedor_codigo: this.formRuteadorManual.get('vendedorfiltro').value,
      territorio_codigo: this.formRuteadorManual.get('territoriofiltro').value > 0 ? this.formRuteadorManual.get('territoriofiltro').value : null,
    };

    // this.loadTerritorios(inputParams);
    // this.loadComunas(inputParams);
  }

  onChangeTerritorio(e) {
    const inputParams = {
      unidad_negocio_codigo: this.permiteUnidadNegocio ? this.formRuteadorManual.get('unidad_negocio_codigo').value : 0,
      fechaDesde: this.formRuteadorManual.get('fechafiltroDesde').value,
      fechaHasta: this.formRuteadorManual.get('fechafiltroHasta').value,
      estado: this.formRuteadorManual.get('estadofiltro').value,
      rut_empresa: this.rutEmpresa,
      comuna_codigo: this.formRuteadorManual.get('comunafiltro').value > 0 ? this.formRuteadorManual.get('comunafiltro').value : null,
      vendedor_codigo: this.formRuteadorManual.get('vendedorfiltro').value > 0 ? this.formRuteadorManual.get('vendedorfiltro').value : null,
      territorio_codigo: this.formRuteadorManual.get('territoriofiltro').value,
    };

    // this.loadVendedores(inputParams);
    // this.loadComunas(inputParams);
  }

  LimpiarData() {
    const inputParams = {
      unidad_negocio_codigo: this.permiteUnidadNegocio ? this.formRuteadorManual.get('unidad_negocio_codigo').value : 0,
      fechaDesde: this.formRuteadorManual.get('fechafiltroDesde').value,
      fechaHasta: this.formRuteadorManual.get('fechafiltroHasta').value,
      estado: this.formRuteadorManual.get('estadofiltro').setValue(null),
      rut_empresa: this.rutEmpresa,
      comuna_codigo: this.formRuteadorManual.get('comunafiltro').setValue(null),
      vendedor_codigo: this.formRuteadorManual.get('vendedorfiltro').setValue(null),
      territorio_codigo: this.formRuteadorManual.get('territoriofiltro').setValue(null),
    };
    this.formRuteadorManual.get('estadofiltro').setValue('2');

    this.buscarPorFiltros();

    this.showTable = false;
    this.sumTotalCajas = 0;
    this.sumTotalUnidad = 0;
    this.sumTotalDocumentos = 0;
    this.sumTotalMonto = 0;
    this.sumTotalPeso = 0;
    this.sumTotalVolumen = 0;

    this.total_documentos = 0;
    this.documentos_entregados = 0;
    this.documentos_pendientes = 0;
    this.numeros_clientes = 0;
  }

  loadInitialData() {
    if (this.permiteUnidadNegocio === true && (this.formRuteadorManual.get('unidad_negocio_codigo').value == null || this.formRuteadorManual.get('unidad_negocio_codigo').value == 0)) {
      this.log('wait until unidad_negocio_codigo is ready');
      return;
    }

    const fecha = this.formRuteadorManual.get('fechafiltroDetalleRecorridoDesde').value;
    const fechaHasta = this.formRuteadorManual.get('fechafiltroDetalleRecorridoHasta').value;
    const estado = '0'; //Buscara todos los estados
    this.ObtenerCamiones(fecha, fechaHasta, estado);
    this.loadCamiones();
    this.loadChofer();
  }

  //* CARGA DE VENDEDORES EN SELECT/

  loadVendedores(inputParams) {
    this.log('inputParams', JSON.stringify(inputParams));
    // this.obtenerDocumentosRecorridoByFiltro(inputParams);
  }

  //* CARGA DE COMUNAS EN SELECT/

  loadComunas(inputParams) {
    this.log('inputParams', JSON.stringify(inputParams));
    // this.obtenerDocumentosRecorridoByFiltro(inputParams);
  }

  //* CARGA DE TERRITORIOS EN SELECT/

  loadTerritorios(inputParams) {
    this.log('inputParams', JSON.stringify(inputParams));

    // this.obtenerDocumentosRecorridoByFiltro(inputParams);
  }

  //* CARGA DE ESTADOS EN SELECT/

  loadEstado() {
    throw new Error('Method not implemented.');
  }

  //* CARGA DE ESTADOS DETALLE EN SELECT/

  loadEstadoDetalle() {
    throw new Error('Method not implemented.');
  }

  //* CARGA DE CHOFERES EN SELECT/

  loadChofer() {
    const inputParams = {
      entidad: {
        rut_empresa: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        tipobusqueda: 1,
      },
    };
    this.choferSucursalService.obtenerchoferSucursalxRutEmpresaSucursal(inputParams, ({ respuesta, mensajes }) => {
      if (mensajes && mensajes.length > 0) {
        this._messageRendererService.showErrors(mensajes);
        return;
      }
      const { registros } = respuesta;
      this.optionsChofer = registros.map((p) => ({ value: p.rut, label: p.nombre, ...p }));
    });
  }

  //* CARGA DE CAMIONES EN SELECT/

  loadCamiones() {
    const inputParams = {
      rut_empresa: this.rutEmpresa,
      sucursal_codigo: this.sucursalCodigo,
      tipobusqueda: 1,
    };

    this.optionsUnidadesDeNegocio = [];

    this.camionService.obtenerCamionSucursalxRutEmpresaSucursal(inputParams, ({ respuesta, mensajes }) => {
      if (mensajes && mensajes.length > 0) {
        this._messageRendererService.showErrors(mensajes);
        return;
      }

      const { registros } = respuesta;
      this.optionsCamion = registros.map((p) => ({ value: p.patente, label: p.patente + ' - ' + p.descripcion, ...p }));
    });
  }

  //* CARGA DE UNIDAD DE NEGOCIO EN SELECT/

  loadUnidadNegocio() {
    const inputParams = {
      entidad: {
        empresa_rut: this.rutEmpresa,
        tipo: 1,
      },
    };

    this.optionsUnidadesDeNegocio = [];

    this.unidadNegocioService.obtenerUnidadNegocio(inputParams, ({ respuesta }) => {
      if (respuesta != null) {
        const { registros } = respuesta;
        this.optionsUnidadesDeNegocio = registros.map((unidad_negocio) => ({
          value: unidad_negocio.codigo,
          label: unidad_negocio.nombre,
        }));
        this.AddUnidadDeNegocioValidators();
        this.isCheckingUnidadNegocio = false;
      }
    });
  }

  AddUnidadDeNegocioValidators() {
    this._formValidatorsService.selectFirstOrDefault(this.formRuteadorManual.get('unidad_negocio_codigo'), this.optionsUnidadesDeNegocio);
    this.formRuteadorManual.get('unidad_negocio_codigo').setValidators([Validators.required]);
    this.formRuteadorManual.get('unidad_negocio_codigo').updateValueAndValidity();
  }

  //Creacion de Formulario
  private createForms() {
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth();

    this.formRuteadorManual = this.fb.group({
      unidad_negocio_codigo: [null, []],
      fechafiltroDesde: [currentDate, []],
      fechafiltroHasta: [currentDate, []],
      estadofiltro: [null, [Validators.required]],
      estadofiltroDetalleRecorrido: [null],
      fechafiltroDetalleRecorridoDesde: [currentDate, null],
      fechafiltroDetalleRecorridoHasta: [currentDate, null],
      comunafiltro: [null, [Validators.required]],
      vendedorfiltro: [null, [Validators.required]],
      territoriofiltro: [null, [Validators.required]],
    });
  }

  obtenerDocumentosRecorridoByFiltro(inputParams) {
    this.log('OBTENER DOCUMENTOS RECORRIDOS POR FILTRO', JSON.stringify(inputParams));
    this.loadingDetalles = true;
    this.ruteadorService.obtenerDocumentosbyFiltros(inputParams, ({ respuesta }) => {
      if (respuesta == null) {
        this.loadingDetalles = false;
        return;
      }

      this.log('ELIMINAR RECORRIDO', JSON.stringify(respuesta));
      const { registros } = respuesta;
      const self = this;

      let ListaDocumentosRecorridos = registros;
      //SUMATORIA PARA CALCULAR TOTALES
      this.resumen_totales = {
        // monto_total_cajas: _.sumBy(ListaDocumentosRecorridos, 'total_cantidad'),
        // monto_total_unidad: _.sumBy(ListaDocumentosRecorridos, 'total_unidad'),
        monto_total_peso: _.sumBy(ListaDocumentosRecorridos, 'total_peso'),
        monto_total: _.sumBy(ListaDocumentosRecorridos, 'total_monto'),
        monto_total_volumen: _.sumBy(ListaDocumentosRecorridos, 'total_volumen'),
        monto_total_doc: ListaDocumentosRecorridos.length,
      };

      // this.sumTotalCajas = this.resumen_totales.monto_total_cajas;
      // this.sumTotalUnidad = this.resumen_totales.monto_total_unidad;
      this.sumTotalPeso = Math.round(this.resumen_totales.monto_total_peso);
      this.sumTotalMonto = this.resumen_totales.monto_total;
      this.sumTotalVolumen = Number(this.resumen_totales.monto_total_volumen.toFixed(2));
      this.sumTotalDocumentos = this.resumen_totales.monto_total_doc;
      this.obtenerTotalesResumen(ListaDocumentosRecorridos);

      this.listdocumentRec = ListaDocumentosRecorridos; // documentos a mostrar en tabla

      self.documentosRecorridos = [];
      self.documentosRecorridos = ListaDocumentosRecorridos;
      // puentos Mapa
      self.beaches = [];
      let sel: any;
      let contador = 0;
      ListaDocumentosRecorridos.forEach((element) => {
        let colorcode = self.obtenerCodigoColor();

        sel = { value: element.codigo, label: element.nombre };

        contador = contador + 1;

        if (element.folio_recorrido_Detalle > 0) {
          self.beaches.push([
            element.direccion_completa,
            element.latitud,
            element.longitud,
            contador,
            'https://chart.apis.google.com/chart?chst=d_map_pin_letter&chld=%E2%80%A2|' + colorcode.toUpperCase(),
          ]);
          self.beachesAUX = self.beaches;
        } else {
          self.beaches.push([element.direccion_completa, element.latitud, element.longitud, contador, '']);
          self.beachesAUX = self.beaches;
        }
      });

      //* SELECT COMUNA */
      this.optionsComuna = [];
      // let sel2_: any;
      // sel2_ = { value: '', label: 'Seleccionar Comuna' };
      // this.optionsComuna.push(sel2_);
      let sel2: any;
      let listaComunaDocumentoDistinct = registros.filter((thing, i, arr) => arr.findIndex((t) => t.comuna === thing.comuna) === i);
      listaComunaDocumentoDistinct.forEach((element) => {
        sel2 = { value: element.comuna_codigo, label: element.comuna };
        this.optionsComuna.push(sel2);
      });

      //* SELECT VENDEDOR */
      this.optionsVendedor = [];
      // let sel3_: any;
      // sel3_ = { value: '', label: 'Seleccionar Vendedor' };
      // this.optionsVendedor.push(sel3_);
      let sel3: any;
      let listaVendedorDocumentoDistinct = registros.filter((thing, i, arr) => arr.findIndex((t) => t.vendedor === thing.vendedor) === i);
      listaVendedorDocumentoDistinct.forEach((element) => {
        sel3 = { value: element.vendedor_codigo, label: element.vendedor };
        this.optionsVendedor.push(sel3);
      });

      //* SELECT TERRITORIOS */

      this.optionsTerritorios = [];
      // let sel4_: any;
      // sel4_ = { value: '', label: 'Seleccionar Terrirorio' };
      // this.optionsTerritorios.push(sel4_);
      let sel4: any;
      let listaTerritorioDocumentoDistinct = registros.filter((thing, i, arr) => arr.findIndex((t) => t.territorio === thing.territorio) === i);
      listaTerritorioDocumentoDistinct.forEach((element) => {
        sel4 = { value: element.territorio_codigo, label: element.territorio };
        this.optionsTerritorios.push(sel4);
      });

      this.isCheckingUnidadNegocio = false;

      this.listdocumentRec.map((pedido, index) => {
        pedido.additionalInfo = {};
        pedido.additionalInfo.index = index;
        pedido.additionalInfo.checked = false;
      });

      this.CheckBoxAllValue = false;
      this.areSelected = true;
      this.loadingDetalles = false;
    });
  }

  obtenerTotalesResumen(lista) {
    this.listaDocumentoAsignado = [];
    this.listaDocumentoAsignado = _.cloneDeep(lista);
    this.listaDocumentoAsignado.forEach((mov) => {
      delete mov.__typename;
      delete mov.estado;
      delete mov.estado_cliente;
      delete mov.nombre_cliente;
      delete mov.total_monto;
      delete mov.total_unidad;
      delete mov.total_cantidad;
      delete mov.total_volumen;
      delete mov.total_peso;
      delete mov.fecha_emision;
      delete mov.folio_recorrido_Detalle;
      delete mov.additionalInfo;
      delete mov.comuna_codigo;
      delete mov.vendedor_codigo;
      delete mov.territorio_codigo;
      delete mov.prioridad;
    });
    const inputParams = {
      lista: this.listaDocumentoAsignado,
    };
    this.log('TOTAL ASIGNACION', JSON.stringify(inputParams));
    this.ruteadorService.obtenerTotalesAsignacion(inputParams, ({ respuesta }) => {
      if (respuesta == null) {
        this.loadingDetalles = false;
        return;
      }

      //this.log('TOTAL ASIGNACION', JSON.stringify(respuesta));
      //const { respuesta } = respuesta;
      let listaDocAsignadoTotales = respuesta;

      this.sumTotalCajas = listaDocAsignadoTotales.total_cantidad;
      this.sumTotalUnidad = listaDocAsignadoTotales.total_unidad;
      // this.sumTotalPeso = Math.round(this.resumen_totales.monto_total_peso);
      // this.sumTotalMonto = this.resumen_totales.monto_total;
      // this.sumTotalVolumen = this.resumen_totales.monto_total_volumen;
      // this.sumTotalDocumentos = this.resumen_totales.monto_total_doc;
    });
  }

  showModalVerDetalleCamionChofer(cam: any) {
    console.log('=>(ruteador.component.ts:1044) cam', cam);
    const self = this;
    self.updateBloqueoProcesoSignalR();
    self.obtenerDetalleCamionChofer(cam);
    self.verDetalleCamionChoferModal.show();
  }

  obtenerDetalleCamionChofer(cam: any) {
    this.loadingDetalles = true;
    this.recorridoDetalleSeleccionado = cam;

    const inputParams = {
      excel: false,
      recorrido_codigo: cam.recorrido_codigo,
    };

    this.log('OBTENER DETALLE CAMION CHOFER', JSON.stringify(inputParams));

    this.ruteadorService.obtenerDetalleCamionChofer(inputParams, ({ mensajes, respuesta }) => {
      if (mensajes && mensajes.length > 0) {
        this._messageRendererService.showInfoMessages(mensajes);
        this._messageRendererService.showErrors(mensajes);
        this.loadingDetalles = false;
        return;
      }
      this.log('OBTENCION DE DETALLE CAMION', JSON.stringify(respuesta));

      const { registros } = respuesta;
      this.listadoDetalleCamionChoferAll = [];
      console.log(this.listadoDetalleCamionChoferAll);
      this.listadoDetalleCamionChoferAll = registros;

      console.log(registros);
      this.obtenerTotalesModalAsignacion(this.listadoDetalleCamionChoferAll);
      this.paginationContextDetalles.RecordsCount = this.listadoDetalleCamionChoferAll.length; //totalRegistros
      this.paginationContextDetalles.PagesCount = Math.ceil(this.paginationContextDetalles.RecordsCount / this.paginationContextDetalles.RecordsByPage); //totalPaginas

      // this.beaches_rutas = [];
      // let sel: any;
      // let contador = 0;
      // this.listadoDetalleCamionChoferAll.forEach((element) => {
      //   sel = { value: element.codigo, label: element.nombre };
      //   contador = contador + 1;
      //   this.beaches_rutas.push([element.direccion_completa, element.latitud, element.longitud, contador]);
      // });

      this.showPageDetalles(this.paginationContextDetalles.CurrentPage);

      this.loadingDetalles = false;

      // this.calculateAndDisplayRoute(this.directionsService, this.directionsRenderer);
    });
  }

  obtenerTotalesModalAsignacion(lista) {
    this.listaModalAsignado = [];
    this.listaModalAsignado = _.cloneDeep(lista);
    this.listaModalAsignado.forEach((mov) => {
      mov.folio = mov.numero_documento;
      mov.tipo_dte_codigo = mov.tipo_documento;

      delete mov.__typename;
      delete mov.recorrido_codigo;
      delete mov.volumen;
      delete mov.peso;
      delete mov.comuna_despacho;
      delete mov.vendedor_nombre;
      delete mov.rutaArchivo;
      delete mov.fecha_emision_folio;
      delete mov.numero_documento;
      delete mov.tipo_documento;
      delete mov.total_documentos;
      delete mov.cajas;
      delete mov.unidad;
      delete mov.nombre_cliente;
      delete mov.estado;
      delete mov.prioridad;
    });
    const inputParams = {
      lista: this.listaModalAsignado,
    };
    this.log('TOTAL ASIGNACION', JSON.stringify(inputParams));
    this.ruteadorService.obtenerTotalesAsignacion(inputParams, ({ respuesta }) => {
      if (respuesta == null) {
        this.loadingDetalles = false;
        return;
      }

      //this.log('TOTAL ASIGNACION', JSON.stringify(respuesta));
      //const { respuesta } = respuesta;
      let listaDocAsignadoTotales = respuesta;
      this.totalCajas = listaDocAsignadoTotales.total_cantidad;
      this.totalUnidad = listaDocAsignadoTotales.total_unidad;
    });
  }

  public myDatePickerOptions: IMyOptions = {
    editableDateField: false,
  };

  obtenerNumeroAleaotrio(min, max) {
    let numAle = Math.random() * (max - min) + min;
    return Math.round(numAle);
  }

  componentToHex(c) {
    var hex = c.toString(16);
    return hex.length == 1 ? '0' + hex : hex;
  }

  rgbToHex(r, g, b) {
    return this.componentToHex(r) + this.componentToHex(g) + this.componentToHex(b);
  }

  obtenerCodigoColor() {
    let r = this.obtenerNumeroAleaotrio(0, 255);
    let g = this.obtenerNumeroAleaotrio(0, 255);
    let b = this.obtenerNumeroAleaotrio(0, 255);
    return this.rgbToHex(r, g, b);
  }

  showPageDetalles(pageNumber: number) {
    this.paginationContextDetalles.CurrentPage = pageNumber;
    const start = (this.paginationContextDetalles.CurrentPage - 1) * this.paginationContextDetalles.RecordsByPage;
    this.listadoDetalleCamionChofer = _.slice(this.listadoDetalleCamionChoferAll, start, start + this.paginationContextDetalles.RecordsByPage);
  }

  // Función para calcular distancia euclidiana entre dos puntos
  private calculateDistance(point1: { lat: number, lng: number }, point2: { lat: number, lng: number }): number {
    const latDiff = point1.lat - point2.lat;
    const lngDiff = point1.lng - point2.lng;
    return Math.sqrt(latDiff * latDiff + lngDiff * lngDiff);
  }

  // Función de debug para verificar el orden optimizado
  private debugRouteOrder(destinations: any[], optimized: any[], origin: { lat: number, lng: number }) {
    console.log('=== DEBUG DE OPTIMIZACIÓN DE RUTA ===');
    console.log('Origen:', origin);
    console.log('Destinos originales:');
    destinations.forEach((dest, index) => {
      console.log(`  ${index + 1}. ${dest.originalData[0]} - Lat: ${dest.coordinates.lat}, Lng: ${dest.coordinates.lng}`);
    });
    console.log('Destinos optimizados:');
    optimized.forEach((dest, index) => {
      const distance = this.calculateDistance(
        index === 0 ? origin : optimized[index - 1].coordinates,
        dest.coordinates
      );
      console.log(`  ${index + 1}. ${dest.originalData[0]} - Lat: ${dest.coordinates.lat}, Lng: ${dest.coordinates.lng} (distancia: ${distance.toFixed(6)})`);
    });

    // Calcular distancia total de la ruta optimizada
    let totalDistance = 0;
    for (let i = 0; i < optimized.length; i++) {
      const from = i === 0 ? origin : optimized[i - 1].coordinates;
      const to = optimized[i].coordinates;
      totalDistance += this.calculateDistance(from, to);
    }
    console.log(`Distancia total de la ruta optimizada: ${totalDistance.toFixed(6)}`);
    console.log('=====================================');
  }

  // Función auxiliar para optimizar la ruta usando algoritmo del vecino más cercano
  private optimizeRouteOrder(destinations: any[], origin: { lat: number, lng: number }): any[] {
    if (destinations.length <= 1) return destinations;

    const optimized = [];
    const unvisited = [...destinations]; // Copia del array
    let currentLocation = origin;

    // Algoritmo del vecino más cercano
    while (unvisited.length > 0) {
      let nearestIndex = 0;
      let minDistance = this.calculateDistance(currentLocation, unvisited[0].coordinates);

      // Encontrar el punto más cercano al actual
      for (let i = 1; i < unvisited.length; i++) {
        const distance = this.calculateDistance(currentLocation, unvisited[i].coordinates);
        if (distance < minDistance) {
          minDistance = distance;
          nearestIndex = i;
        }
      }

      // Agregar el punto más cercano a la ruta optimizada
      const nearest = unvisited.splice(nearestIndex, 1)[0];
      optimized.push(nearest);
      currentLocation = nearest.coordinates;
    }

    return optimized;
  }

  calculateAndDisplayRoute(directionsService, directionsRenderer) {
    const self = this;

    let param = {};
    let paramOrigin = '-33.5973549, -70.5452478';

    if (self.beaches_rutas.length == 1) {
      let paramdest = self.beaches_rutas[0][1] + ',' + self.beaches_rutas[0][2];

      param = {
        origin: paramOrigin, //casa matriz
        destination: paramdest,
        optimizeWaypoints: true,
        travelMode: google.maps.TravelMode.DRIVING,
      };
    } else if (self.beaches_rutas.length > 1) {
      // Enfoque mejorado: usar algoritmo de optimización de rutas más inteligente

      // 1. Crear todos los waypoints sin predeterminar el destino
      const waypts = [];
      const allDestinations = [];

      // Recopilar todas las coordenadas
      self.beaches_rutas.forEach((element, index) => {
        const destination = element[1] + ',' + element[2];
        allDestinations.push({
          location: destination,
          coordinates: { lat: parseFloat(element[1]), lng: parseFloat(element[2]) },
          index: index,
          originalData: element
        });
      });

      // 2. Algoritmo mejorado: usar optimización del vecino más cercano
      const origin = { lat: -33.5973549, lng: -70.5452478 };

      // 3. Optimizar la ruta usando el algoritmo del vecino más cercano
      const optimizedDestinations = this.optimizeRouteOrder(allDestinations, origin);

      // Debug: mostrar el orden optimizado
      this.debugRouteOrder(allDestinations, optimizedDestinations, origin);

      // 4. Usar el enfoque optimizado: todos como waypoints menos el último
      if (optimizedDestinations.length >= 2) {
        // Tomar todos menos el último como waypoints
        for (let i = 0; i < optimizedDestinations.length - 1; i++) {
          waypts.push({
            location: optimizedDestinations[i].location,
            stopover: true
          });
        }

        // El último punto será el destino final
        const finalDestination = optimizedDestinations[optimizedDestinations.length - 1].location;

        param = {
          origin: paramOrigin,
          destination: finalDestination,
          waypoints: waypts,
          optimizeWaypoints: true, // Esto permite a Google Maps optimizar el orden automáticamente
          travelMode: google.maps.TravelMode.DRIVING,
        };
      } else {
        // Fallback: si solo hay 2 puntos, usar el más lejano como destino
        waypts.push({
          location: optimizedDestinations[0].location,
          stopover: true
        });

        param = {
          origin: paramOrigin,
          destination: optimizedDestinations[1].location,
          waypoints: waypts,
          optimizeWaypoints: true,
          travelMode: google.maps.TravelMode.DRIVING,
        };
      }
    }

    this.beaches_rutas.splice(0, this.beaches_rutas.length);

    // Ejecutar la ruta directamente sin setTimeout innecesario
    setTimeout(() => {
      directionsService.route(param, (response, status) => {
        if (status === 'OK') {
          directionsRenderer.setDirections(response);

          // Mostrar información de la ruta optimizada
          if (response.routes && response.routes[0] && response.routes[0].waypoint_order) {
            console.log('Orden optimizado de waypoints:', response.routes[0].waypoint_order);
          }
        } else {
          console.error('Error en el cálculo de ruta:', status);
          self.showError('Ha ocurrido un error al calcular rutas: ' + status);
          // self.mostrarRutasModal.hide();
        }
      });
    }, 1000); // Reducir timeout para mejor experiencia de usuario
  }

  initMap() {
    this.optionsEstado = [
      { value: '0', label: 'Seleccionar Estado' },
      { value: '1', label: 'Asignado' },
      { value: '2', label: 'No Asignado' },
    ];
    this.optionsEstadoDetalle = [
      { value: '0', label: 'Todos los estados' },
      { value: '1', label: 'En carga' },
      { value: '2', label: 'Despachado' },
      { value: '3', label: 'Liquidado' },
      // { value: "4", label: "No asignado" }
    ];
    this.formRuteadorManual.get('estadofiltro').setValue('2');
    this.formRuteadorManual.get('estadofiltroDetalleRecorrido').setValue('0');
    this.date = new Date();
  }

  onMapReady(map) {
    const inputParams = {
      unidad_negocio_codigo: this.permiteUnidadNegocio ? this.formRuteadorManual.get('unidad_negocio_codigo').value : 0,
      fechaDesde: this.formRuteadorManual.get('fechafiltroDesde').value,
      fechaHasta: this.formRuteadorManual.get('fechafiltroHasta').value,
      estado: this.formRuteadorManual.get('estadofiltro').value,
      rut_empresa: this.rutEmpresa,
      comuna_codigo: this.formRuteadorManual.get('comunafiltro').value === '' ? null : this.formRuteadorManual.get('comunafiltro').value,
      vendedor_codigo: this.formRuteadorManual.get('vendedorfiltro').value === '' ? null : this.formRuteadorManual.get('vendedorfiltro').value,
      territorio_codigo: this.formRuteadorManual.get('territoriofiltro').value === '' ? null : this.formRuteadorManual.get('territoriofiltro').value,
    };

    this.globalMap = map;

    this.log('DATOS ON MAP READY', JSON.stringify(inputParams));

    this.obtenerDocumentosRecorridoByFiltro(inputParams);
    setTimeout(() => this.initDrawingManager(map), 1000);
  }

  onMapReadyShowRutas(map) {
    const self = this;
    self.globalMap_rutas = map;
    self.directionsService = new google.maps.DirectionsService();
    self.directionsRenderer = new google.maps.DirectionsRenderer();
    self.directionsRenderer.setMap(map);
  }

  initDrawingManager(map: any) {
    const options = {
      drawingControl: true,
      drawingControlOptions: {
        drawingModes: ['polygon'],
      },
      polygonOptions: {
        draggable: true,
        editable: true,
      },
      drawingMode: google.maps.drawing.OverlayType.POLYGON,
    };
    this.drawingManager = new google.maps.drawing.DrawingManager(options);
    this.drawingManager.setMap(map);

    var polygonArray3 = [];
    var beaches_ = this.beaches;
    var markers_ = [];
    google.maps.event.clearListeners(map, 'polygoncomplete');

    this.zoomeExtends(map, this.beaches);
    google.maps.event.addListener(this.drawingManager, 'polygoncomplete', function (polygon) {
      if (this.polygon) {
        this.polygon.setMap(null);
      }
      this.polygon = polygon;

      document.getElementById('info').innerHTML = '';

      for (var i = 0; i < polygon.getPath().getLength(); i++) {
        var puntospol = polygon.getPath().getAt(i).toUrlValue(6);
        polygonArray3.push(new google.maps.LatLng(puntospol.split(',')[0], puntospol.split(',')[1]));
      }

      var bermudaTriangle = new google.maps.Polygon({
        paths: [polygonArray3],
      });

      for (let i = 0; i < beaches_.length; i++) {
        const beach = beaches_[i];
        markers_.push(
          new google.maps.Marker({
            position: new google.maps.LatLng(beach[1], beach[2]),
            title: beach[0],
            zIndex: beach[3],
          })
        );
      }
      for (var i = 0; i < markers_.length; i++) {
        var marker = markers_[i];
        var polygons = bermudaTriangle;
        if (google.maps.geometry.poly.containsLocation(marker.getPosition(), polygons)) {
          document.getElementById('info').innerHTML += marker.getPosition() + ';';
        } else {
          // document.getElementById('info').innerHTML += marker.getPosition() + "outside polygon" + "<br>"
        }
      }
      markers_ = [];
      polygonArray3 = [];
      var bermudaTriangle = new google.maps.Polygon({
        paths: [],
      });
    });
  }

  zoomeExtends(map: any, beachesP: any[]) {
    const self = this;
    var beaches_ = beachesP;
    var markers_ = [];

    for (let i = 0; i < beaches_.length; i++) {
      const beach = beaches_[i];
      markers_.push(
        new google.maps.Marker({
          position: new google.maps.LatLng(beach[1], beach[2]),
          title: beach[0],
          zIndex: beach[3],
        })
      );
    }
    var bounds = new google.maps.LatLngBounds();
    if (markers_.length > 0) {
      for (var i = 0; i < markers_.length; i++) {
        bounds.extend(markers_[i].getPosition());
      }
      map.fitBounds(bounds);
    }
  }

  showInfo(mensaje) {
    const options = { opacity: 1 };
    this.toastrService.info(mensaje, 'Mensaje Información!', options);
  }

  showSuccess(mensaje) {
    const options = { opacity: 1 };
    this.toastrService.success(mensaje, 'Mensaje Éxito!', options);
  }

  showError(mensaje) {
    const options = { opacity: 1 };
    this.toastrService.error(mensaje, 'Mensaje Error!', options);
  }
  //* CORRESPONDIENTE AL METODO BUSCAR/
  buscarPorFiltros() {
    //MOSTRAR TABLA
    this.showTable = true;

    const inputParams = {
      unidad_negocio_codigo: this.permiteUnidadNegocio ? this.formRuteadorManual.get('unidad_negocio_codigo').value : 0,
      fechaDesde: this.formRuteadorManual.get('fechafiltroDesde').value,
      fechaHasta: this.formRuteadorManual.get('fechafiltroHasta').value,
      estado: parseInt(this.formRuteadorManual.get('estadofiltro').value),
      rut_empresa: this.rutEmpresa,
      comuna_codigo: this.formRuteadorManual.get('comunafiltro').value === '' ? null : this.formRuteadorManual.get('comunafiltro').value,
      vendedor_codigo: this.formRuteadorManual.get('vendedorfiltro').value === '' ? null : this.formRuteadorManual.get('vendedorfiltro').value,
      territorio_codigo: this.formRuteadorManual.get('territoriofiltro').value === '' ? null : this.formRuteadorManual.get('territoriofiltro').value,
    };

    // FILTRO DE CAMIONES QUE ACTUAN JUNTO AL FILTRO DE DOCUMENTOS
    // this.formRuteadorManual.get('fechafiltroDetalleRecorridoDesde').setValue(this.formRuteadorManual.get('fechafiltroDesde').value);
    // this.formRuteadorManual.get('fechafiltroDetalleRecorridoHasta').setValue(this.formRuteadorManual.get('fechafiltroHasta').value);
    // this.formRuteadorManual.get('estadofiltroDetalleRecorrido').setValue(this.optionsEstadoDetalle[0].value);

    this.log('BUSCAR POR FILTROS', JSON.stringify(inputParams));

    this.buscarPorFiltroDetalle();

    // ENVIAR PARAMETRO PARA RESUMEN SIN RUTEMPRESA
    delete inputParams.rut_empresa;
    this.obtenerResumenDocumentos(inputParams);

    // ENVIAR PARAMETRO PARA OBTENER DOCUMENTOS CON RUTEMPRESA
    inputParams.rut_empresa = this.rutEmpresa;
    this.obtenerDocumentosRecorridoByFiltro(inputParams);
  }

  obtenerResumenDocumentos(inputParams) {
    this.ruteadorService.obtenerResumenDocumentos(inputParams, ({ respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this._messageRendererService.showErrors('No se puede mostrar el resumen de documentos');
        return;
      }

      const { registros } = respuesta;

      this.log('RESUMEN DOCUMENTOS', JSON.stringify(registros));

      var resumen = registros;

      if (resumen.length > 0) {
        this.total_documentos = resumen[0].total_documentos;
        this.documentos_entregados = resumen[0].documentos_entregados;
        this.documentos_pendientes = resumen[0].documentos_pendientes;
        this.numeros_clientes = resumen[0].numeros_clientes;
      }
    });
  }

  buscarPorFiltroDetalle(): void {
    const estado = this.formRuteadorManual.get('estadofiltroDetalleRecorrido').value;
    const fecha = this.formRuteadorManual.get('fechafiltroDetalleRecorridoDesde').value;
    const fechaHastaDetalle = this.formRuteadorManual.get('fechafiltroDetalleRecorridoHasta').value;
    this.ObtenerCamiones(fecha, fechaHastaDetalle, estado);
  }

  onCargaRutas() {
    const estado = this.formRuteadorManual.get('estadofiltroDetalleRecorrido').value;
    const fecha = this.formRuteadorManual.get('fechafiltroDetalleRecorridoDesde').value;
    const fechaHastaDetalle = this.formRuteadorManual.get('fechafiltroDetalleRecorridoHasta').value;
    this.ObtenerCamiones(fecha, fechaHastaDetalle, estado);
  }

  despacharRecorrido(cam: any) {
    console.log('dame cam', cam);
    this.tittle = 'Despachar Camión';
    this.message = '¿Está seguro de realizar despacho?';
    this.modalConfirm.show(() => {
      this.despacharRecorridoAux(cam);
    });
  }

  despacharRecorridoAux(cam: any) {
    const self = this;
    const inputParams = {
      entidad: {
        recorrido_codigo: cam.recorrido_codigo,
        despachado: true,
        rut_empresa: this.rutEmpresa,
      },
    };

    this.ruteadorService.despacharRecorrido(inputParams, ({ respuesta }) => {
      setTimeout(() => self.buscarPorFiltros(), 1000);
      self.showSuccess('La solicitud de despacho se ha realizado con éxito.');
    });
  }

  EditarCamion(cam: any) {
    // console.log(cam);
    // const self = this;
    // this.formRuta.get('fechaMain').setValue(cam.fecha);
    this.verAddEditRutasModal.showEdit(cam);

    // this.recorridoSeleccionado = {
    //   checked: false,
    //   chofer_rut: cam.chofer_rut,
    //   fecha: cam.fecha,
    //   nombre_chofer: cam.nombre_chofer,
    //   patente: cam.patente,
    //   // index:    0
    //   recorrido_codigo: cam.recorrido_codigo,
    //   total_facturas: cam.total_facturas,
    // };

    // this.recorridoSeleccionado = cam;
    // console.log('=>(ruteador.component.ts:185) this.recorridoSeleccionado', this.recorridoSeleccionado);
    // if (this.recorridoSeleccionado) {
    //   this.formRuta.get('camion').setValue(this.recorridoSeleccionado.patente);
    //   this.formRuta.get('chofer').setValue(this.recorridoSeleccionado.chofer_rut);
    //   this.setCamion();
    //   this.setChofer();
    // }
  }

  eliminarCamion(cam: any) {
    const self = this;

    const title = 'Eliminar';
    const message = '¿Está seguro de eliminar registro?';

    this.modalConfirm.showWithInlineConfig(title, message, () => {
      const _recorrido = _.cloneDeep(cam);
      delete _recorrido.__typename;
      const inputParams = {
        entidad: {
          chofer_rut: cam.chofer_rut,
          codigo: cam.recorrido_codigo,
          camion_patente: cam.patente,
          sucursal_codigo: this.sucursalCodigo,
          rut_empresa: this.rutEmpresa,
          activo: false,
          //unidad_negocio: this.formRuta.get('negocio').value
        },
      };
      this.recorridoService.eliminar(inputParams, ({ mensajes, respuesta }) => {
        const ok = respuesta !== null;
        if (!ok) {
          this.messageRendererService.showErrors(mensajes);
          return;
        }
        this.toastService.success('Operación realizada');
        this.buscarPorFiltroDetalle();
      });
      // setTimeout(() => this.buscarPorFiltros(), 1000);
    });
  }

  showModalverAddEditRutasModal() {
    this.verAddEditRutasModal.showAdd();
  }

  UpdateFiltros() {
    this.buscarPorFiltros();
    this.sumCajasSelect = 0;
    this.sumUnidadSelect = 0;
    this.sumPesoSelect = 0;
    this.sumVolumenSelect = 0;
    this.sumMontoSelect = 0;
    this.listdocumentRecSelect.length = 0;
  }

  showModalAsignarCamionRutas(editar: boolean = false) {
    const self = this;

    // if (this.listdocumentRecSelect.length > 0) {
    self.beachesSeleccionados = [];

    this.listdocumentRecSelect.forEach((element) => {
      self.beachesSeleccionados.push({
        latitud: element.latitud,
        longitud: element.longitud,
      });
    });

    let beachesSeleccionadosDistinc = self.beachesSeleccionados.filter((thing, i, arr) => arr.findIndex((t) => t.latitud === thing.latitud) === i);
    self.beachesSeleccionados = [];

    beachesSeleccionadosDistinc.forEach((element) => {
      let sel2 = { latitud: element.latitud, longitud: element.longitud };
      self.beachesSeleccionados.push(sel2);
    });

    // CREAR/EDITAR RUTA
    const filtroFecha = this.formRuteadorManual.get('fechafiltroDesde').value; // return
    this.modalAsignarCamion.show(
      self.beachesSeleccionados,
      self.documentosRecorridos,
      self.listadoCamionChofer,
      this.permiteUnidadNegocio ? this.formRuteadorManual.get('unidad_negocio_codigo').value : 0,
      filtroFecha,
      editar
    );

    //LIMPIAR DOCUMENTOS SELECCIONADOS
    // this.listdocumentRecSelect.splice(0, this.listdocumentRecSelect.length)
    // } else {
    //   self.showInfo('Debe seleccionar al menos un documento.');
    // }
  }

  checkAllChange({ checked }) {
    this.listdocumentRec.forEach((mov) => {
      mov.additionalInfo.checked = checked;
    });

    const dato = this.listdocumentRec.map((doc) => {
      // cliente.checked = false
      this.removeElementTypename(doc);
      const params = {
        cliente_proveedor_rut: doc.cliente_proveedor_rut,
        comuna: doc.comuna,
        comuna_codigo: doc.comuna_codigo,
        direccion_completa: doc.direccion_completa,
        direccion_codigo: doc.direccion_codigo,
        estado_cliente: doc.estado_cliente,
        fecha_emision: doc.fecha_emision,
        folio: doc.folio,
        latitud: doc.latitud,
        longitud: doc.longitud,
        nombre_cliente: doc.nombre_cliente,
        rut_emisor: doc.rut_emisor,
        rut_receptor: doc.rut_receptor,
        territorio: doc.territorio,
        territorio_codigo: doc.territorio_codigo,
        seleccion: doc.additionalInfo.checked,
        tipo_dte_codigo: doc.tipo_dte_codigo,
        total_cantidad: doc.total_cantidad,
        total_unidad: doc.total_unidad,
        total_monto: doc.total_monto,
        total_peso: doc.total_peso,
        total_volumen: doc.total_volumen,
        vendedor: doc.vendedor,
        vendedor_codigo: doc.vendedor_codigo,
      };

      return params;
    });

    this.listdocumentRecAll = dato;
    this.listdocumentRecSelect = dato.filter((x) => x.seleccion == true);
    const volumenSeleccionado = _.sumBy(this.listdocumentRecSelect, 'total_volumen');
    // (this.sumCajasSelect = _.sumBy(this.listdocumentRecSelect, 'total_cantidad')),
    //   (this.sumUnidadSelect = _.sumBy(this.listdocumentRecSelect, 'total_unidad')),
    (this.sumPesoSelect = Math.round(_.sumBy(this.listdocumentRecSelect, 'total_peso'))),
      (this.sumMontoSelect = _.sumBy(this.listdocumentRecSelect, 'total_monto')),
      (this.sumVolumenSelect = volumenSeleccionado.toFixed(2)),
      this.handleAreSelected();
    this.obtenerTotalesResumenSeleccion(this.listdocumentRecSelect);
  }

  checkAllRecorridosChange({ checked }) {
    this.checkAllRecorrido = checked;
    this.listadoCamionChofer.forEach((cam) => {
      if (cam.codigo_estado != 4 && cam.total_documentos > 0) {
        cam.seleccion = checked;
      }
    });
  }

  checkDetalle({ index }, { checked }) {
    const _indexPage = this.listdocumentRec.findIndex((p) => p.additionalInfo.index === index);
    this.listdocumentRec[_indexPage].additionalInfo.checked = checked;

    const dato = this.listdocumentRec.map((doc) => {
      // cliente.checked = false
      this.removeElementTypename(doc);
      const params = {
        cliente_proveedor_rut: doc.cliente_proveedor_rut,
        comuna: doc.comuna,
        comuna_codigo: doc.comuna_codigo,
        direccion_completa: doc.direccion_completa,
        direccion_codigo: doc.direccion_codigo,
        estado_cliente: doc.estado_cliente,
        fecha_emision: doc.fecha_emision,
        folio: doc.folio,
        latitud: doc.latitud,
        longitud: doc.longitud,
        nombre_cliente: doc.nombre_cliente,
        rut_emisor: doc.rut_emisor,
        rut_receptor: doc.rut_receptor,
        territorio: doc.territorio,
        territorio_codigo: doc.territorio_codigo,
        seleccion: doc.additionalInfo.checked,
        tipo_dte_codigo: doc.tipo_dte_codigo,
        total_cantidad: doc.total_cantidad,
        total_unidad: doc.total_unidad,
        total_monto: doc.total_monto,
        total_peso: doc.total_peso,
        total_volumen: doc.total_volumen,
        vendedor: doc.vendedor,
        vendedor_codigo: doc.vendedor_codigo,
      };

      return params;
    });

    this.listdocumentRecAll = dato;
    this.listdocumentRecSelect = dato.filter((x) => x.seleccion == true);
    //(this.sumCajasSelect = _.sumBy(this.listdocumentRecSelect, 'total_cantidad')),
    //(this.sumUnidadSelect = _.sumBy(this.listdocumentRecSelect, 'total_unidad')),
    (this.sumPesoSelect = Math.round(_.sumBy(this.listdocumentRecSelect, 'total_peso'))),
      (this.sumMontoSelect = _.sumBy(this.listdocumentRecSelect, 'total_monto')),
      (this.sumVolumenSelect = _.sumBy(this.listdocumentRecSelect, 'total_volumen')),
      this.handleAreSelected();
    this.obtenerTotalesResumenSeleccion(this.listdocumentRecSelect);
  }

  checkRecorridoChange(index, { checked }) {
    // console.log('Check recorrido change', checked, index);
    this.listadoCamionChofer[index].seleccion = checked;
  }

  obtenerTotalesResumenSeleccion(lista) {
    this.listaDocumentoAsignadoSelect = [];
    this.listaDocumentoAsignadoSelect = _.cloneDeep(lista);
    this.listaDocumentoAsignadoSelect.forEach((mov) => {
      delete mov.__typename;
      delete mov.estado;
      delete mov.estado_cliente;
      delete mov.nombre_cliente;
      delete mov.total_monto;
      delete mov.total_unidad;
      delete mov.total_cantidad;
      delete mov.total_volumen;
      delete mov.total_peso;
      delete mov.fecha_emision;
      delete mov.folio_recorrido_Detalle;
      delete mov.additionalInfo;
      delete mov.comuna_codigo;
      delete mov.vendedor_codigo;
      delete mov.territorio_codigo;
      delete mov.seleccion;
      delete mov.prioridad;
    });
    const inputParams = {
      lista: this.listaDocumentoAsignadoSelect,
    };
    this.log('TOTAL ASIGNACION', JSON.stringify(inputParams));
    this.ruteadorService.obtenerTotalesAsignacion(inputParams, ({ respuesta }) => {
      if (respuesta == null) {
        this.loadingDetalles = false;
        return;
      }

      //this.log('TOTAL ASIGNACION', JSON.stringify(respuesta));
      //const { respuesta } = respuesta;
      let listaDocAsignadoTotalesSelect = respuesta;
      this.sumCajasSelect = listaDocAsignadoTotalesSelect.total_cantidad;
      this.sumUnidadSelect = listaDocAsignadoTotalesSelect.total_unidad;
      // this.sumTotalCajas = listaDocAsignadoTotales.total_cantidad;
      // this.sumTotalUnidad = listaDocAsignadoTotales.total_unidad;
      // this.sumTotalPeso = Math.round(this.resumen_totales.monto_total_peso);
      // this.sumTotalMonto = this.resumen_totales.monto_total;
      // this.sumTotalVolumen = this.resumen_totales.monto_total_volumen;
      // this.sumTotalDocumentos = this.resumen_totales.monto_total_doc;
    });
  }

  marcar(index, doc) {
    console.log(index);
    if (doc.additionalInfo.checked) this.HighlightRow = index;
    else this.HighlightRow = index;
  }

  ClickedRow(index) {
    this.PintarRow = index;
  }

  marcarFilaDocDetalle(index) {
    this.HighlightRow = index;
    this.ClickedRow(index);
  }

  private removeElementTypename(register: any) {
    delete register.__typename;
    return register;
  }

  CerrarDetalleDoc() {
    this.PintarRow = null;
  }

  handleAreSelected() {
    if (!this.listdocumentRec || this.listdocumentRec.length == 0) this.areSelected = false;
    this.areSelected = this.listdocumentRec.filter((mov) => mov.additionalInfo.checked).length > 0;
  }

  showModalmostrarRutas(cam: any) {
    this.loadingDetalles = true;
    this.recorridoDetalleSeleccionado = cam;

    const inputParams = {
      excel: false,
      recorrido_codigo: cam.recorrido_codigo,
    };

    this.log('OBTENER DETALLE CAMION CHOFER', JSON.stringify(inputParams));

    this.ruteadorService.obtenerDetalleCamionChofer(inputParams, ({ mensajes, respuesta }) => {
      if (mensajes && mensajes.length > 0) {
        this.messageRendererService.showInfoMessages(mensajes);
        this.messageRendererService.showErrors(mensajes);
        this.loadingDetalles = false;
        return;
      }
      this.log('OBTENCION DE DETALLE CAMION', JSON.stringify(respuesta));

      const { registros } = respuesta;
      this.listadoDetalleCamionChoferAll = [];
      console.log(this.listadoDetalleCamionChoferAll);
      this.listadoDetalleCamionChoferAll = registros;

      console.log(registros);
      // this.obtenerTotales(this.listadoDetalleCamionChoferAll);
      this.paginationContextDetalles.RecordsCount = this.listadoDetalleCamionChoferAll.length; //totalRegistros
      this.paginationContextDetalles.PagesCount = Math.ceil(this.paginationContextDetalles.RecordsCount / this.paginationContextDetalles.RecordsByPage); //totalPaginas

      this.beaches_rutas = [];
      let sel: any;
      let contador = 0;
      this.listadoDetalleCamionChoferAll.forEach((element) => {
        sel = { value: element.codigo, label: element.nombre };
        contador = contador + 1;
        this.beaches_rutas.push([element.direccion_completa, element.latitud, element.longitud, contador]);
      });

      this.showPageDetalles(this.paginationContextDetalles.CurrentPage);

      this.loadingDetalles = false;
      this.mostrarRutasModal.loadAndShow(this.beaches_rutas);
    });
  }

  checkAll(event): void {
    if (event.checked) {
      this.listadoDetalleDocumentos = this.listadoDetalleCamionChofer;
    } else {
      this.listadoDetalleDocumentos = [];
    }
  }
  checkHandle(event: any, doc: any): void {
    if (event.checked) {
      this.listadoDetalleDocumentos.push(doc);
    } else {
      this.listadoDetalleDocumentos = this.listadoDetalleDocumentos.filter((x) => x.numero_documento !== doc.numero_documento);
    }
  }
  isChecked(docNum: number): boolean {
    return this.listadoDetalleDocumentos.some((x) => x.numero_documento === docNum);
  }

  eliminarRecorrido(cam: any) {
    this.tittle = 'Liberar';
    this.message = '¿Está seguro de liberar el registro?';

    const inputParams = {
      entidad: {
        recorrido_codigo: cam.recorrido_codigo,
        rut_emisor: this.rutEmpresa,
      },
    };

    this.log('ELIMINAR RECORRIDO', JSON.stringify(inputParams));

    this.modalConfirm.show(() => {
      this._recorridoDetalleService.eliminarRecorrido(inputParams, ({ mensajes, respuesta }) => {
        const ok = respuesta !== null;
        if (!ok) {
          this._messageRendererService.showErrors(mensajes);
          return;
        }

        this.log('ELIMINACIÓN DE RECORRIDO', JSON.stringify(mensajes, respuesta));

        this.toastrService.success('Operación exitosa');
        this.buscarPorFiltros();
        this.listadoDetalleCamionChofer.splice(0, this.listadoDetalleCamionChofer.length);
        this.listadoDetalleCamionChofer = [];
      });
    });
  }

  // showModalPdfDetalleDoc(type: 'XLS' | 'PDF', cam: any): void {
  //   console.log('muestrame el valor', cam);
  //   const inputParams = {
  //     retornaPDF: type === 'PDF' ? true : false,
  //     recorrido_codigo: cam.recorrido_codigo,
  //   };

  //   this.ruteadorService.obtenerDetalleCamionChoferpdf(inputParams, ({ mensajes, respuesta }) => {
  //     const ok = respuesta !== null;
  //     if (!ok) {
  //       this._messageRendererService.showErrors(mensajes);
  //       return;
  //     }
  //     if (respuesta) this.fileDownloadService.VerifyAndDownload(respuesta.registros[0].rutaArchivo);
  //     console.log(
  //       '🚀 ~ file: ruteador.component.ts ~ line 1485 ~ RuteadorComponent ~ this._ruteadorService.obtenerDetalleCamionChofer ~ respuesta.registros[0].rutaArchivo',
  //       respuesta.registros[0].rutaArchivo
  //     );
  //   });
  // }

  // showModalPdf_data(cam: any) {
  //   this.ObtenerDataToPdf(cam);
  // }

  showModalExcel_data(cam: any) {
    this.ObtenerDataToExcel(cam);
  }

  ObtenerDataToExcel(cam: any) {
    const inputParams = {
      recorrido_codigo: String(cam.recorrido_codigo),
      total_facturas: String(cam.total_facturas),
      total_documentos: String(cam.total_documentos),
    };

    this._recorridoDetalleService.obtenerDataToExcel(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      const { registros } = respuesta;
      console.log(registros);
      if (respuesta) this.fileDownloadService.VerifyAndDownload(registros[0].rutaArchivo);
    });
  }

  // GENERA LOS 3 PDFs
  ObtenerDataToPdf() {
    const inputParams = {
      entidad: {
        tipo_notificacion_codigo: 7,
        categoria_modulo_codigo: 2,
        environment_functions: ENVIRONMENT_FUNCTIONS,
        rut_empresa: this.rutEmpresa,
        rut_usuario: this.rutUsuario,
        sucursal_codigo: this.sucursalCodigo,
        esDetalleRecorrido: false,
        listaRecorridos: this.listadoCamionChofer.filter((x) => x.seleccion).map((x) => ({
          recorrido_codigo: x.recorrido_codigo,
          total_facturas: x.total_facturas,
          total_documentos: x.total_documentos,
        })),
      }
    }

    console.log(inputParams);

    this.loadingPdf = true;
    this.messageLoading = 'Generando los PDFs... Una vez generado se mostrará en las notificaciones';
    this.sendMessage(inputParams);
  }

  // GENERA EL PDF DETALLE
  ObtenerDataToPdfModal(recorrido: any) {
    const inputParams = {
      entidad: {
        tipo_notificacion_codigo: 7,
        categoria_modulo_codigo: 2,
        environment_functions: ENVIRONMENT_FUNCTIONS,
        rut_empresa: this.rutEmpresa,
        rut_usuario: this.rutUsuario,
        sucursal_codigo: this.sucursalCodigo,
        esDetalleRecorrido: true,
        listaRecorridos: [{
          recorrido_codigo: recorrido.recorrido_codigo,
          total_facturas: recorrido.total_facturas,
          total_documentos: recorrido.total_documentos,
        }]
      }
    }

    console.log(recorrido);
    console.log(inputParams);

    this.loadingPdfModal = true;
    this.messageLoading = 'Generando PDF... Una vez generado se mostrará en las notificaciones';
    this.sendMessage(inputParams);
  }

  cerrarModalDetalleCamionChofer() {
    this.updateBloqueoProcesoSignalR();
    this.verDetalleCamionChoferModal.hide();
  }

  eliminarRecorridoDetalleList(): void {
    this.tittle = 'Liberar';
    if (this.listadoDetalleDocumentos.length > 1) {
      this.message = '¿Está seguro de liberar los registros?';
    } else {
      this.message = '¿Está seguro de liberar el registro?';
    }

    this.listadoDetalleCamionChoferAll = [];
    this.modalConfirm.show(() => {
      this.eliminarListaRecorridoDetalle();
      this.updateRecorridoDetalle();
    });
  }

  eliminarListaRecorridoDetalle = () => {
    var docList: any[] = [];
    this.listadoDetalleDocumentos.forEach((value) => {
      var data = {
        folio: value.numero_documento,
        cliente_proveedor_rut: value.cliente_proveedor_rut,
        tipo_dte_codigo: value.tipo_documento,
        recorrido_codigo: value.recorrido_codigo,
      };
      docList.push(Object.assign({}, data));
    });
    var inputParams: any = {
      entidad: {
        objet: docList,
      },
    };

    this.log('ELIMINAR LISTA RECORRIDOS DETALLE', JSON.stringify(inputParams));

    this._recorridoDetalleService.eliminarListaByFolioTipoDocumento(inputParams, ({ mensajes, respuesta }) => {
      this.log('ELIMINACION DE LISTA RECORRIDOS DETALLE', JSON.stringify(respuesta, mensajes));

      if (mensajes && mensajes.length > 0) {
        console.log('err');
        this._messageRendererService.showInfoMessages(mensajes);
        this._messageRendererService.showErrors(mensajes);
        this.loadingDetalles = false;
        return;
      }
      docList.forEach((value) => {
        this.listadoDetalleCamionChofer = this.listadoDetalleCamionChofer.filter((p) => p.numero_documento !== value.folio);
      });

      this.listadoDetalleDocumentos = [];
      this.buscarPorFiltros();

      document.getElementById('info').innerHTML = '';
    });

    if (this.listadoDetalleCamionChoferAll.length == this.listadoDetalleDocumentos.length) {
      this.verDetalleCamionChoferModal.hide();
    }
  };

  ReAsignarRecorridoDetalleList() {
    this.tittle = 'Reasignar';
    if (this.listadoDetalleDocumentos.length > 1) {
      this.message = '¿Está seguro de reasignar los registros?';
    } else {
      this.message = '¿Está seguro de reasignar el registro?';
    }

    this.listadoDetalleCamionChoferAll = [];
    this.modalConfirm.show(() => {
      this.ReAsignarListaRecorridoDetalle();
      // this.updateRecorridoDetalle();
    });
  }

  checkDetalleReAsignar(ListDocumentosAsignados) {
    console.log('lista de documentos Asignados', ListDocumentosAsignados);

    let arrayFechas = ListDocumentosAsignados.entidad.objet.map((fechaActual) => fechaActual.fecha_emision_folio);
    var min = arrayFechas.reduce(function (valor1, valor2) {
      return new Date(valor1) < new Date(valor2) ? valor1 : valor2;
    });
    const minDate = min.toString().split('T');
    const DateUse = minDate[0];
    console.log(DateUse);

    const fechaHastaRutaCamiones = this.formRuteadorManual.get('fechafiltroDetalleRecorridoHasta').value;

    const inputParams = {
      unidad_negocio_codigo: this.permiteUnidadNegocio ? this.formRuteadorManual.get('unidad_negocio_codigo').value : 0,
      fechaDesde: DateUse.toString(),
      fechaHasta: fechaHastaRutaCamiones,
      estado: 2, //no asignados
      rut_empresa: this.rutEmpresa,
      comuna_codigo: null,
      vendedor_codigo: null,
      territorio_codigo: null,
    };

    var DocumentosNoAsignados = [];
    this.ruteadorService.obtenerDocumentosbyFiltros(inputParams, ({ respuesta }) => {
      if (respuesta == null) {
        return;
      }

      const { registros } = respuesta;
      const self = this;

      let ListaDocumentosRecorridos = registros;
      //SUMATORIA PARA CALCULAR TOTALES
      self.listaDocumentosReasignar = ListaDocumentosRecorridos; // documentos a mostrar en tabla

      self.documentosRecorridos = [];
      self.documentosRecorridos = ListaDocumentosRecorridos;
      // puentos Mapa
      self.beaches = [];
      let sel: any;
      let contador = 0;
      ListaDocumentosRecorridos.forEach((element) => {
        let colorcode = self.obtenerCodigoColor();

        sel = { value: element.codigo, label: element.nombre };

        contador = contador + 1;

        if (element.folio_recorrido_Detalle > 0) {
          self.beaches.push([
            element.direccion_completa,
            element.latitud,
            element.longitud,
            contador,
            'https://chart.apis.google.com/chart?chst=d_map_pin_letter&chld=%E2%80%A2|' + colorcode.toUpperCase(),
          ]);
          self.beachesAUX = self.beaches;
        } else {
          self.beaches.push([element.direccion_completa, element.latitud, element.longitud, contador, '']);
          self.beachesAUX = self.beaches;
        }
      });

      //* SELECT COMUNA */
      this.optionsComuna = [];
      // let sel2_: any;
      // sel2_ = { value: '', label: 'Seleccionar Comuna' };
      // this.optionsComuna.push(sel2_);
      let sel2: any;
      let listaComunaDocumentoDistinct = registros.filter((thing, i, arr) => arr.findIndex((t) => t.comuna === thing.comuna) === i);
      listaComunaDocumentoDistinct.forEach((element) => {
        sel2 = { value: element.comuna_codigo, label: element.comuna };
        this.optionsComuna.push(sel2);
      });

      //* SELECT VENDEDOR */
      this.optionsVendedor = [];
      let sel3_: any;
      sel3_ = { value: '', label: 'Seleccionar Vendedor' };
      this.optionsVendedor.push(sel3_);
      let sel3: any;
      let listaVendedorDocumentoDistinct = registros.filter((thing, i, arr) => arr.findIndex((t) => t.vendedor === thing.vendedor) === i);
      listaVendedorDocumentoDistinct.forEach((element) => {
        sel3 = { value: element.vendedor_codigo, label: element.vendedor };
        this.optionsVendedor.push(sel3);
      });

      //* SELECT TERRITORIOS */

      this.optionsTerritorios = [];
      let sel4_: any;
      sel4_ = { value: '', label: 'Seleccionar Terrirorio' };
      this.optionsTerritorios.push(sel4_);
      let sel4: any;
      let listaTerritorioDocumentoDistinct = registros.filter((thing, i, arr) => arr.findIndex((t) => t.territorio === thing.territorio) === i);
      listaTerritorioDocumentoDistinct.forEach((element) => {
        sel4 = { value: element.territorio_codigo, label: element.territorio };
        this.optionsTerritorios.push(sel4);
      });

      this.AddUnidadDeNegocioValidators();
      this.isCheckingUnidadNegocio = false;

      this.listaDocumentosReasignar.map((pedido, index) => {
        pedido.additionalInfo = {};
        pedido.additionalInfo.index = index;
        pedido.additionalInfo.checked = false;
      });

      this.CheckBoxAllValue = false;
      this.areSelected = true;

      // console.log("MUESTRAME LOS DOCUMENTOS NO ASIGNADOS 1", this.listaDocumentosReasignar, ListDocumentosAsignados);

      //todo: ASIGNAR - MODIFICAR input -> traer ListDocumentosAsignados
      // const inputExample = {
      //   entidad: {
      //     objet:[
      //       {
      //           folio: 4974,

      //       },
      //       {
      //           folio: 4975,

      //       }
      //   ]
      //   }
      // }

      let docParaAsig = ListDocumentosAsignados.entidad.objet.map((obj) => obj.folio);
      let dato = this.listaDocumentosReasignar.filter((name) => docParaAsig.includes(name.folio));
      dato.forEach((x) => {
        x.additionalInfo.checked = true;
      });

      this.listdocumentRecSelect = dato.filter((x) => x.additionalInfo.checked == true);

      console.log(this.listdocumentRecSelect);

      (this.sumCajasSelect = _.sumBy(this.listdocumentRecSelect, 'total_cantidad')),
        (this.sumUnidadSelect = _.sumBy(this.listdocumentRecSelect, 'total_unidad')),
        (this.sumPesoSelect = Math.round(_.sumBy(this.listdocumentRecSelect, 'total_peso'))),
        (this.sumMontoSelect = _.sumBy(this.listdocumentRecSelect, 'total_monto')),
        (this.sumVolumenSelect = _.sumBy(this.listdocumentRecSelect, 'total_volumen')),
        this.handleAreSelected();

      //OCULTAR DETALLE DOCUMENTO
      this.verDetalleCamionChoferModal.hide();

      //MOSTRAR MODAL DE ASIGNACION
      if (this.listdocumentRecSelect.length > 0) {
        self.beachesSeleccionados = [];

        this.listdocumentRecSelect.forEach((element) => {
          self.beachesSeleccionados.push({
            latitud: element.latitud,
            longitud: element.longitud,
          });
        });

        let beachesSeleccionadosDistinc = self.beachesSeleccionados.filter((thing, i, arr) => arr.findIndex((t) => t.latitud === thing.latitud) === i);
        self.beachesSeleccionados = [];

        beachesSeleccionadosDistinc.forEach((element) => {
          let sel2 = { latitud: element.latitud, longitud: element.longitud };
          self.beachesSeleccionados.push(sel2);
        });

        // CREAR/EDITAR RUTA
        const filtroFecha = this.formRuteadorManual.get('fechafiltroDetalleRecorridoDesde').value; // return

        console.log(self.beachesSeleccionados, self.documentosRecorridos);

        this.modalAsignarCamion.show(
          self.beachesSeleccionados,
          self.documentosRecorridos,
          self.listadoCamionChofer,
          this.permiteUnidadNegocio ? this.formRuteadorManual.get('unidad_negocio_codigo').value : 0,
          filtroFecha,
          false
        );

        //LIMPIAR DOCUMENTOS SELECCIONADOS
        // this.listdocumentRecSelect.splice(0, this.listdocumentRecSelect.length)
      } else {
        self.showInfo('Debe seleccionar al menos un documento.');
      }
    });
  }

  ReAsignarListaRecorridoDetalle = () => {
    var docList: any[] = [];
    var docListAsig: any[] = [];
    this.listadoDetalleDocumentos.forEach((value) => {
      var data = {
        folio: value.numero_documento,
        cliente_proveedor_rut: value.cliente_proveedor_rut,
        tipo_dte_codigo: value.tipo_documento,
        recorrido_codigo: value.recorrido_codigo,
        fecha_emision_folio: value.fecha_emision_folio,
      };
      docList.push(Object.assign({}, data));
      docListAsig.push(Object.assign({}, data));
    });

    //Bandera para reasignar
    var inputReasignar: any = {
      entidad: {
        objet: docListAsig,
      },
    };

    // PARA ELIMINAR
    var inputParams: any = {
      entidad: {
        objet: docList,
      },
    };

    inputParams.entidad.objet.map((x) => {
      delete x.fecha_emision_folio;
    });
    // this.log('ELIMINAR LISTA RECORRIDOS DETALLE', JSON.stringify(inputParams));
    this._recorridoDetalleService.eliminarListaByFolioTipoDocumento(inputParams, ({ mensajes, respuesta }) => {
      this.log('ELIMINACION DE LISTA RECORRIDOS DETALLE', JSON.stringify(respuesta, mensajes));

      if (mensajes && mensajes.length > 0) {
        console.log('err');
        this._messageRendererService.showInfoMessages(mensajes);
        this._messageRendererService.showErrors(mensajes);
        this.loadingDetalles = false;
        return;
      }
      docList.forEach((value) => {
        this.listadoDetalleCamionChofer = this.listadoDetalleCamionChofer.filter((p) => p.numero_documento !== value.folio);
      });

      this.listadoDetalleDocumentos = [];
      this.buscarPorFiltros();

      document.getElementById('info').innerHTML = '';
      //ABRIR MODAL DE ASIGNACION
      this.checkDetalleReAsignar(inputReasignar);
    });
  };

  downloadExcelPdf(type: 'XLS' | 'PDF', cam: any): void {
    const inputParams = {
      excel: type === 'XLS' ? true : false,
      recorrido_codigo: cam.recorrido_codigo,
    };

    console.log('InputPArams ', inputParams);
    this.ruteadorService.obtenerDetalleCamionChofer(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this._messageRendererService.showErrors(mensajes);
        return;
      }
      if (respuesta) this.fileDownloadService.VerifyAndDownload(respuesta.registros[0].rutaArchivo);
      console.log(
        '🚀 ~ file: ruteador.component.ts ~ line 1485 ~ RuteadorComponent ~ this._ruteadorService.obtenerDetalleCamionChofer ~ respuesta.registros[0].rutaArchivo',
        respuesta.registros[0].rutaArchivo
      );
    });
  }

  setChofer() {
    this.chofer = this.optionsChofer.filter((s) => s.value == this.formRuta.get('chofer').value)[0];
  }

  updateRecorridoDetalle(): void {
    //LIMPIAR MODAL
    this.verDetalleCamionChoferModal.hide();
    this.verDetalleCamionChoferModal.show();
    this.obtenerDetalleCamionChofer(this.recorridoDetalleSeleccionado);
  }
  ObtenerCamiones(fechaDesde: string, fechaHasta: string, estado: string) {
    this.listadoCamionChofer = [];
    const inputParams = {
      fechaDesde: fechaDesde,
      fechaHasta: fechaHasta,
      estado: estado,
      unidad_negocio_codigo: this.permiteUnidadNegocio ? this.formRuteadorManual.get('unidad_negocio_codigo').value : 0,
    };

    this.log('OBTENER CAMIONES', JSON.stringify(inputParams));

    this.loadingCamion = true;
    this.ruteadorService.obtenerCamionChofer(inputParams, ({ mensajes, respuesta }) => {
      if (mensajes && mensajes.length > 0) {
        this._messageRendererService.showInfoMessages(mensajes);
        this._messageRendererService.showErrors(mensajes);
        this.loadingDetalles = false;
        this.loadingCamion = false;
        return;
      }

      const ok = respuesta !== null;
      if (!ok) {
        this._messageRendererService.showErrors(mensajes);
        return;
      }

      const { registros } = respuesta;
      this.log('lISTA CAMIONES DOCUMENTOS', JSON.stringify(registros));

      this.listadoCamionChofer = registros;
      this.loadingCamion = false;
      this.checkAllRecorrido = false;
      this.listadoCamionChofer.forEach((element) => {
        (element.correlativo = element.recorrido_codigo), (element.loadingPdf = false), (element.color = ''), (element.seleccion = false);
      });
    });
  }

  setCamion() {
    this.camion = this.optionsCamion.filter((s) => s.value == this.formRuta.get('camion').value)[0];
  }
  addRuta() {
    this.loading = true;
    const inputParams = {
      entidad: {
        codigo: this.recorridoSeleccionado ? this.recorridoSeleccionado.recorrido_codigo : null,
        chofer_rut: this.formRuta.get('chofer').value,
        camion_patente: this.camion.patente,
        sucursal_codigo: this.sucursalCodigo,
        rut_empresa: this.rutEmpresa,
        limite_volumen: this.camion.volumen,
        limite_monto: 10000000,
        limite_peso: this.camion.peso_maximo,
        fecha_registro: this.formRuta.get('fechaMain').value,
        fecha: this.formRuta.get('fechaMain').value,
        activo: true,
      },
    };

    this.log('inputParams', JSON.stringify(inputParams));

    this.recorridoService.guardar(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this._messageRendererService.showErrors(mensajes);
        return;
      }
      const { empresa_rut } = respuesta;
      this.log('ADD RUTAS', JSON.stringify(respuesta));

      this.onSuccess.emit();
      this.toastrService.success('Operación exitosa');
      this.postProcesoAddRuta();
      this.buscarPorFiltroDetalle();
    });
    this.loading = false;
    this.formRuta.reset();
    this.camion = null;
    this.chofer = null;
  }

  onCamionAsignado() {
    this.buscarPorFiltros();
  }

  EliminarFiltroRutas() {
    const self = this;
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth();
    this.formRuta.get('fechaMain').setValue(currentDate);
    this.formRuta.get('camion').setValue(null);
    this.camion = null;
    this.chofer = null;
    this.formRuta.get('chofer').setValue(null);
  }

  postProcesoAddRuta() {
    this.eventsSubject.next();
  }

  onPageChangeDetalles(context: PaginationContext) {
    this.showPageDetalles(context.RequestedPage);
  }

  sumaCajas(): number {
    const sumaCajas = this.listadoDetalleCamionChofer.reduce((total, obj) => {
      return total + obj.cajas;
    }, 0);
    return sumaCajas;
  }

  sumaVolumen(): number {
    const sumaVolumen = this.listadoDetalleCamionChofer.reduce((total, obj) => {
      return total + obj.volumen;
    }, 0);
    return sumaVolumen;
  }
  sumaDocumentos(): number {
    const sumaDocumentos = this.listadoDetalleCamionChofer.length;
    return sumaDocumentos;
  }
  sumaMonto(): number {
    const sumaMonto = this.listadoDetalleCamionChofer.reduce((total, obj) => {
      return total + obj.total_documentos;
    }, 0);
    return sumaMonto;
  }

  showModalEditarRutasModal(cam: any) {
    this.verAddEditRutasModal.showEdit(cam);
  }

  permiteObtenerPDF(): boolean {
    return this.listadoCamionChofer.some(cam => cam.seleccion === true);
  }
  existePDFs(): boolean {
    return this.listadoCamionChofer.some(cam => cam.codigo_estado != 4 && cam.total_documentos > 0);
  }

  sendMessage(inputParams: any) {
    this.signalRMessageService.send(inputParams).subscribe(
      () => {
        console.log('Mensaje enviado con éxito');
      },
      (error) => {
        this.loadingPdf = false;
        console.error('Error al enviar el mensaje:', error);
      }
    );
  }

  updateBloqueoProcesoSignalR() {
    const entidadRef = { tipo_notificacion_codigo: 7, categoria_modulo_codigo: 2 };
    const bloquearGeneracion = this.signalRMessageService.hasProcesoPendiente(entidadRef);
    if (bloquearGeneracion) {
      this.loadingPdf = true;
      this.loadingPdfModal = true;
      this.messageLoading = 'Existe una generacion de PDFs en curso... Una vez generados se mostrarán en las notificaciones';
    }
  }
}
